import { useContext } from 'react';
import { AppContext } from '../../context/AppContext/context';
import { CreateAptValues } from '../../utils/form/appointmentForm';

function useInitialAppointmentForm() {
  const { state, dispatch } = useContext(AppContext);

  const set = (payload: Partial<CreateAptValues> | null) => {
    dispatch({
      type: 'SET_INITIAL_APPOINTMENT_FORM',
      payload,
    });
  };

  return {
    initialAppointmentForm: state.initialAppointmentForm,
    set,
  };
}

export default useInitialAppointmentForm;
